import { createFeatureSelector } from '@ngrx/store';

export const loyaltyProgramsState = createFeatureSelector<OLO.State, OLO.State.LoyaltyPrograms>('loyaltyPrograms');
